export enum HubEventEnum {
  PostAJobClick = 'post-job-click',
  RegistrationComplete = 'registration-completed',
  SaveAndSubscribe = 'save-subscribe-submitted',
  FormSubmitted = 'form-submitted',
}
